<template>
    <div :class="variantClass" class="hc-alert alert" role="alert">
        <div class="hc-alert-icon" v-if="icon">
            <fa-icon :icon="icon"></fa-icon>
        </div>
        <div class="hc-alert-text">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "HecAlert",
    props: {
        variant: {
            type: String,
            default: null
        },
        icon: {
            type: String,
            default: null
        }
    },
    computed: {
        variantClass() {
            return this.variant ? `alert-${this.variant}` : "alert-info";
        }
    }
};
</script>

<style lang="scss">
.hc-alert.alert {
    display: flex;
    border: 0;
    border-radius: 0.25rem;
    overflow: hidden;

    @media print {
        margin-left: 0;
        border: 1px solid $border-color !important;
    }
}

.hc-alert-icon {
    display: inline-flex;
    align-items: center;
    font-size: 1.125rem;
    line-height: 1;
    color: #fff;
    text-align: center;
    padding: 0.75rem;
    min-width: 2.625rem;
    background: $border-color;

    @each $key, $val in $theme-colors {
        .alert-#{$key} & {
            background: $val;
        }
    }
}

.hc-alert-text {
    display: flex;
    align-items: center;
    flex: 1;
    color: $black;
    padding: 0.75rem;
}
</style>
